<template>
  <!-- cancelConfirmation Modal -->
  <div
    class="modal fade"
    id="cancelConfirmationModal"
    tabindex="-1"
    aria-labelledby="cancelConfirmationModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="cancelConfirmationModalLabel">
            Cancel Confirmation
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="closeModal"
          ></button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label for="cancelRequest"
              >Are you sure you want to cancel the request?</label
            >
            <textarea
              v-model="message"
              class="form-control"
              rows="6"
              id="cancelRequest"
              placeholder="Add Note for Cancelling"
            ></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            style="width: 48.5%"
            data-bs-dismiss="modal"
            @click="closeModal"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-danger"
            style="width: 48.5%"
            data-bs-dismiss="modal"
            @click="cancelRequest"
            :disabled="buttonDisabled"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- rejectRequest Modal -->
  <div
    class="modal fade"
    id="rejectRequestModal"
    tabindex="-1"
    aria-labelledby="rejectRequestModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="rejectRequestModalLabel">
            Reject Confirmation
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="closeModal"
          ></button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label for="rejectRequest"
              >Are you sure you want to reject the request?</label
            >
            <textarea
              v-model="message"
              class="form-control"
              rows="6"
              id="rejectRequest"
              placeholder="Add Note for Rejecting"
            ></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            style="width: 48.5%"
            data-bs-dismiss="modal"
            @click="closeModal"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-danger"
            style="width: 48.5%"
            data-bs-dismiss="modal"
            @click="rejectRequest"
            :disabled="buttonDisabled"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- approveRequest Modal -->
  <div
    class="modal fade"
    id="approveRequestModal"
    tabindex="-1"
    aria-labelledby="approveRequestModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="approveRequestModalLabel">
            Approval Confirmation
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          Are you sure you want to approve the request?
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            style="width: 48.5%"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-success"
            style="width: 48.5%"
            data-bs-dismiss="modal"
            @click="approveRequest"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- deleteConfirmation Modal -->
  <div
    class="modal fade"
    id="deleteConfirmationModal"
    tabindex="-1"
    aria-labelledby="deleteConfirmationModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="deleteConfirmationModalLabel">
            Delete Confirmation
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          Are you sure you want to delete the selected removable file?
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            style="width: 48.5%"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-danger"
            style="width: 48.5%"
            data-bs-dismiss="modal"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useDownloadStore } from "@/stores/download";
import { ref, watch } from "vue";

const message = ref("");
const downloadStore = useDownloadStore();
const props = defineProps({
  selectedId: { type: String },
  serverParams: { type: Object },
});
const selectedPackages: any = ref(props.selectedId);
const serverParams: any = ref(props.serverParams);
const trimMessage = ref("");
const buttonDisabled = ref(true);

watch(
  () => props.selectedId,
  (newId) => (selectedPackages.value = newId)
);

watch(
  () => message.value,
  (updateMessgae) => {
    trimMessage.value = updateMessgae.trim();
    if (trimMessage.value == "") return (buttonDisabled.value = true);
    else return (buttonDisabled.value = false);
  }
);

const approveRequest = async () => {
  await downloadStore.approve(selectedPackages.value, serverParams.value);
};

const rejectRequest = async () => {
  await downloadStore.reject(
    selectedPackages.value,
    message.value,
    serverParams.value
  );
  message.value = "";
};

const cancelRequest = async () => {
  await downloadStore.cancel(
    selectedPackages.value,
    message.value,
    serverParams.value
  );
  message.value = "";
};

const closeModal = () => {
  message.value = "";
};
</script>
